import adImage from '../assets/svgs/adoptzi_logo.svg';
import AdDetails from '../models/AdDetails';
import { WHATSAPP } from './defaultSocialMedia';

const defaultAd = {};
defaultAd[AdDetails.id] = 0;
defaultAd[AdDetails.image] = adImage;
defaultAd[AdDetails.objectname] = "Espacio publicitario";
defaultAd[AdDetails.shortDescription] = "¿Te interesaría publicitarte en este espacio? Presiona el botón contactar para ponerte en contacto con el equipo de Adoptzi.";
defaultAd[AdDetails.longDescription] = "¿Te interesaría publicitarte en este espacio? Presiona el botón contactar para ponerte en contacto con el equipo de Adoptzi.";
defaultAd[AdDetails.socialMedia] = {
  facebook: "https://www.facebook.com/adoptzi",
  website: "https://adoptzi.com",
  instagram: "https://www.instagram.com/adoptzi/",
};
defaultAd[AdDetails.phone] = "42149355";
defaultAd[AdDetails.webpage] = "";
defaultAd[AdDetails.default_media] = WHATSAPP;

export {defaultAd};